import moment from "moment";
import { useEffect } from "react";

import { lckey, _localGet, _localRemove, _localSet } from "../../localStorage";

function useIdleTimeout(defaultTimeout) {
  useEffect(() => {
    function setIdleTimeout() {
      const now = Date.now();
      const env_time = defaultTimeout;
      const idleTimeout = env_time * 60000;
      _localSet(
        `${lckey}_last_updated`,
        moment().format("YYYY-MM-DD HH:mm:ss"),
      );
      _localSet("idleTimeout", now + idleTimeout);
    }

    function checkIdleTimeout() {
      const idleTimeoutTimestamp = parseInt(_localGet("idleTimeout"), 10);
      const now = Date.now();

      if (now > idleTimeoutTimestamp) {
        _localRemove("idleTimeout");
        window.location.href = "/logout";
      }
    }

    function resetIdleTimeout() {
      setIdleTimeout();
    }

    // Set initial timeout
    setIdleTimeout();

    // Add event listeners
    const events = [
      "click",
      "mousemove",
      "mouseup",
      "mousedown",
      "keydown",
      "keypress",
      "keyup",
      "submit",
      "change",
      "mouseenter",
      "scroll",
      "resize",
      "dblclick",
    ];

    events.forEach((event) => {
      document.addEventListener(event, resetIdleTimeout);
    });

    // Check idle timeout every second
    const intervalId = setInterval(checkIdleTimeout, 1000);

    // Cleanup function
    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, resetIdleTimeout);
      });
      clearInterval(intervalId);
    };
  }, [defaultTimeout]);
}

export default useIdleTimeout;
